import { useQuery } from '@tanstack/react-query'
import { checkSetupToken } from '../utils/checkSetupToken'

export function useCheckSetupTokenQuery(
  token: string,
  type: 'setup' | 'reset',
) {
  const query = useQuery<{ isVerified: boolean; message?: string }>({
    queryKey: ['checkSetupToken', type, token],
    queryFn: () => checkSetupToken(token),
    enabled: !!token, // only run if token exists
    staleTime: Infinity, // optional, no need to refetch
  })

  return query // { data, isLoading, isError, error }
}
